import { render, staticRenderFns } from "./ShowMcq.vue?vue&type=template&id=de4615dc&scoped=true"
import script from "./ShowMcq.vue?vue&type=script&lang=js"
export * from "./ShowMcq.vue?vue&type=script&lang=js"
import style0 from "./ShowMcq.vue?vue&type=style&index=0&id=de4615dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4615dc",
  null
  
)

export default component.exports